import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Paper } from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';

const AIAdjustments = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="xl">
      <Box sx={{ mt: 4 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <SettingsIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom>
            {t('pages.aiAdjustments')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t('pages.underConstruction')}
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default AIAdjustments;
